import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ApiKeyUserRequestRow } from '../api-key-request-table.models';

export interface DenyApiKeyRequestEvent {
  requestId: number;
  userName: string;
}

@Component({
  selector: 'tgrid-api-key-requests-table',
  imports: [DatePipe, MatButtonModule],
  templateUrl: './api-key-requests-table.component.html',
  styleUrl: './api-key-requests-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiKeyRequestsTableComponent {
  readonly rows = input.required<ApiKeyUserRequestRow[]>();
  readonly loading = input(false);
  readonly errorMessage = input<string | null>(null);
  readonly approvingRequestIds = input<number[]>([]);

  readonly approveRequest = output<number>();
  readonly denyRequest = output<DenyApiKeyRequestEvent>();

  protected readonly expandedUserId = signal<number | null>(null);
  private readonly approvingSet = computed(() => new Set(this.approvingRequestIds()));

  protected toggleExpanded(userId: number): void {
    this.expandedUserId.update((current) => (current === userId ? null : userId));
  }

  protected isExpanded(userId: number): boolean {
    return this.expandedUserId() === userId;
  }

  protected isApproving(requestId: number): boolean {
    return this.approvingSet().has(requestId);
  }
}

